import React from "react";

const Footer = () => (
  <footer className="footer">
    <h3>
      Coded With <i className="fas fa-coffee coffee-icon" /> By Chris Ewald
    </h3>
  </footer>
);

export default Footer;
